import { Link as ReactLink } from 'react-router-dom';
import { get } from 'lodash';
import { bool, object } from 'prop-types';
import * as paths from '../../config/paths';

import styled from 'styled-components';
import {
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@podiumhq/design-system';
import { colors } from '@podiumhq/podium-ui';

const TabAdminHamburger = props => {
  const {
    skyhookCanAccessMarketplace,
    skyhookCanReadIntegrationsList,
    skyhookCanUseRogbot,
    skyhookCanViewFlock,
    skyhookCanViewPartner,
    currentUser,
  } = props;

  const partnerUid = get(currentUser, 'partnerUid', null);
  const role = get(currentUser, 'roleSlug', '');

  const limitHeaderView = role === 'view_only_support' || role === 'support';

  return (
    <Menu>
      <HamburgurMenu hideChevron>
        <Icon
          type={'Hamburger'}
          boxSize={9}
          color="silver.lightest"
          marginRight=".5em"
        />
      </HamburgurMenu>
      <MenuList backgroundColor="#565353" enableAnimations>
        {skyhookCanUseRogbot && (
          <Link to={paths.ROGBOT_USERS}>
            <MenuItemContainer>Rogbot</MenuItemContainer>
          </Link>
        )}
        {skyhookCanViewPartner && partnerUid ? null : (
          <Link to={paths.PHONE_LOOKUP}>
            <MenuItemContainer>Tools</MenuItemContainer>
          </Link>
        )}
        {(skyhookCanViewFlock || !limitHeaderView) && (
          <>
            {skyhookCanViewPartner && partnerUid ? null : (
              <Link to={paths.PARTNERS}>
                <MenuItemContainer>Partners</MenuItemContainer>
              </Link>
            )}
            {skyhookCanReadIntegrationsList && (
              <Link to={paths.INTEGRATIONS}>
                <MenuItemContainer>Integrations</MenuItemContainer>
              </Link>
            )}
          </>
        )}
        {skyhookCanAccessMarketplace && (
          <Link to={paths.MARKETPLACE}>
            <MenuItemContainer>Marketplace</MenuItemContainer>
          </Link>
        )}
      </MenuList>
    </Menu>
  );
};

TabAdminHamburger.propTypes = {
  skyhookCanAccessMarketplace: bool.isRequired,
  skyhookCanReadIntegrationsList: bool.isRequired,
  skyhookCanUseRogbot: bool.isRequired,
  skyhookCanViewFlock: bool.isRequired,
  skyhookCanViewPartner: bool.isRequired,
  currentUser: object.isRequired,
};

const HamburgurMenu = styled(MenuButton)`
  background-color: #2d2f31 !important;
  padding: 0px !important;
  margin-right: 5px !important;
`;

const Link = styled(ReactLink)`
  font-weight: 500;
  font-size: 14px;
  color: ${colors.white};
  cursor: pointer;
  margin: 1rem 12px;
  display: block;
`;

const MenuItemContainer = styled(MenuItem)`
  width: 215px !important;
`;

export default TabAdminHamburger;
